import { render, staticRenderFns } from "./hipaa.vue?vue&type=template&id=24e17fbb&scoped=true"
import script from "./hipaa.vue?vue&type=script&lang=js"
export * from "./hipaa.vue?vue&type=script&lang=js"
import style0 from "./hipaa.vue?vue&type=style&index=0&id=24e17fbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e17fbb",
  null
  
)

export default component.exports